import { Dispatch, SetStateAction, useMemo, useState } from "react";
import { SelectPicker } from "rsuite";

import { useGlobalAppViews } from "../AddViewDrawer/ReuseViews/useGlobalAppViews";
import { Page, PageView } from "../../../types/GlobalInterfaces";
import usePage from "../../../api/api-hooks/pages/usePage";
import ModulePicker from "../../Modules/ModulePicker";

const empty: [] = [];
export default function ReusableViewConfig({
  globalAppID,
  reuseViewID,
  setReuseViewID,
  pageID,
  parentViewID,
  subViews,
}: {
  globalAppID: string | undefined;
  reuseViewID: string;
  setReuseViewID: Dispatch<SetStateAction<string>>;
  pageID: string;
  parentViewID: string | undefined;
  subViews?: PageView[];
}) {
  const { page }: { page: Page } = usePage(pageID);
  const [pickerOpened, setPickerOpened] = useState(false);
  const [moduleAPIName, setModuleAPIName] = useState("");

  const { views, appName, validModuleAPINames, loadingViews } =
    useGlobalAppViews(globalAppID!, !!globalAppID, "views");

  const viewsLoading = pickerOpened && loadingViews;

  // TOOD: Finish this.
  if (!globalAppID) return null;

  /**
   * Filters the Views based on the selected moduleAPIName and
   */
  const finalViews = useMemo(() => {
    if (!Array.isArray(views)) return empty;

    // Only storing the Views that match with the selected moduleAPIName
    const filteredByModuleAPIName = views.filter(
      (v) => v?.ModuleAPIName === moduleAPIName
    );

    let viewIDs: string[] = [];
    if (parentViewID && subViews?.length) {
      viewIDs = subViews?.map((v) => v.id);
      viewIDs.push(parentViewID);
    } else {
      viewIDs = page.Views.map((v) => v.id);
    }

    // Returning the Views that are not in the page Views array.
    return filteredByModuleAPIName.filter((v) => !viewIDs.includes(v._id));
  }, [views, moduleAPIName, pageID]);

  return (
    <>
      <h4>Data Source</h4>
      <ModulePicker
        value={moduleAPIName}
        onChange={setModuleAPIName}
        defaultOpen={!moduleAPIName}
        acceptableModules={validModuleAPINames}
      />
      {moduleAPIName && (
        <>
          <h4 className="tw:pt-5">{appName} Views</h4>
          <SelectPicker
            block
            preventOverflow
            searchable={finalViews?.length > 3}
            placeholder="Select a View"
            onOpen={() => setPickerOpened(true)}
            value={reuseViewID}
            onChange={(val) => setReuseViewID(val || "")}
            data={finalViews}
            loading={viewsLoading}
            renderMenuItem={(label, item) => {
              return (
                <div>
                  <div className="tw:font-bold">{label}</div>
                  <small className="tw:block tw:truncate tw:w-[550px]">
                    {item?.Description}
                  </small>
                </div>
              );
            }}
            labelKey={"PageViewName"}
            valueKey={"_id"}
          />
        </>
      )}
    </>
  );
}
